<template>
  <div id="kali-devi">
    
    <canvas
      id="c"
      ref="canvas"
    ></canvas>
    <div id="loading">
      <div>
        <div>...loading...</div>
        <div class="progress">
          <div id="progressbar"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>


class MinMaxGUIHelper {
  constructor(obj, minProp, maxProp, minDif) {
    this.obj = obj
    this.minProp = minProp
    this.maxProp = maxProp
    this.minDif = minDif
  }
  get min() {
    return this.obj[this.minProp]
  }
  set min(v) {
    this.obj[this.minProp] = v
    this.obj[this.maxProp] = Math.max(this.obj[this.maxProp], v + this.minDif)
  }
  get max() {
    return this.obj[this.maxProp]
  }
  set max(v) {
    this.obj[this.maxProp] = v
    this.min = this.min // this will call the min setter
  }
}

// import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js"
// import { FBXLoader } from "three/examples/jsm/loaders/FBXLoader"
// import { THREE } from "three/build/three.min.js"
// https://github.com/mrdoob/three.js/blob/master/examples/webgl_geometry_spline_editor.html

import { OrbitControls } from "@/assets/js/custom-orbit-controls/ThreeOrbitControlsGizmo__OrbitControls.js"
import { OrbitControlsGizmo } from "@/assets/js/custom-orbit-controls/ThreeOrbitControlsGizmo__OrbitControlsGizmo.js"
import { FlyControls } from 'three/examples/jsm/controls/FlyControls.js'
import { GUI } from "@/assets/js/three-js-gui-helper.js"

import { SkeletonUtils } from "three/examples/jsm/utils/SkeletonUtils.js"
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader"
import * as THREE from "three"
import {mapGetters} from 'vuex'

export default {
  name: "kali-devi",
  data() {
    return {
      audioMantra: null,
      selected: "customCharacter",
      appEl: null,
      language: "pt",
      skeleton: null,
      model: null,
      renderer: null,
      frameIds: [],
      frameid: null,
      gui: null,
      controls: null,
      controlsGizmo: null,
      distanceSpanEl: null,
      tobs: {},
      isLandscape: window.innerHeight > window.innerWidth,
      isMobile:
        /Android|webOS|iPhone|iPad|Mac|Macintosh|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        ),
    }
  },
  computed: {
    ...mapGetters(['volume'])
  },
  watch: {
    volume(nv) {
      if (nv) {
        // console.log(`volume value`, nv)
        this.audioMantra.volume = nv * .01
      } 
    },
  },
  destroyed() {
    this.renderer.setAnimationLoop(null)
    cancelAnimationFrame(this.frameid)
    this.audioMantra.pause()
    this.renderer.domElement.parentElement.removeChild(this.renderer.domElement)
    window.onkeydown = null
    document
      .querySelectorAll(".orbit-controls-gizmo")
      .forEach((el) => el.remove())

    document.querySelectorAll("body > div.dg.ac").forEach((el) => el.remove())

    // this.appEl.classList.add("position-absolute")
  },
  mounted() {
    this.$route.params.lang && this.language != this.$route.params.lang
      ? (this.language = this.$route.params.lang)
      : null
    this.$parent.$on("changeLang", this.setLang)
    window.ondeviceorientation = (e) => this.handlerOrientation
    // this.footer = document.querySelector("footer")
    this.createAudioMantra()
    

    const canvas = document.querySelector("#c"),
      renderer = new THREE.WebGLRenderer({ canvas }),
      fov = 21,
      aspect = 100,
      near = 1,
      far = 2800,
      camera = new THREE.PerspectiveCamera(fov, aspect, near, far),
      light = new THREE.DirectionalLight(0xffffff)
      // helper = new THREE.DirectionalLightHelper(light, 5),
      // flyControls = new FlyControls(camera, renderer.domElement)

    // flyControls.movementSpeed = 1000
    // flyControls.domElement = renderer.domElement
    // flyControls.rollSpeed = Math.PI / 24
    // flyControls.autoForward = false
    // flyControls.dragToLook = false

    // window.flyControls = flyControls

    renderer.physicallyCorrectLights = true;
    renderer.outputEncoding = THREE.sRGBEncoding;
    renderer.setPixelRatio( window.devicePixelRatio );

    this.renderer = renderer


    camera.position.set(0, 1.7, 21)
    window.camera = camera

    // const controls = new OrbitControls(camera, canvas)
    function updateCamera() {
      camera.updateProjectionMatrix()
    }

    this.gui = new GUI()
    this.gui
      .add(camera, "fov", 1, 180, { language: this.language })
      .onChange(updateCamera)
    const minMaxGUIHelper = new MinMaxGUIHelper(camera, "near", "far", 0.1)
    // this.gui.add(minMaxGUIHelper, 'min', 0.1, 50, 0.1).name('near').onChange(updateCamera);
    // this.gui.add(minMaxGUIHelper, 'max', 0.1, 50, 0.1).name('far').onChange(updateCamera);

    const controls = new OrbitControls(camera, renderer.domElement)
    const controlsGizmo = new OrbitControlsGizmo(controls, {
      size: 100,
      padding: 8,
    })

    this.controls = controls
    this.controlsGizmo = controlsGizmo
    // controls.target.set(0, 1, 1)
    // controls.ed.target.set(1,0,-35)
    controls.ed.target.set(1, 2, 2)
 
    window.controls = controls
    controls.ed.update()

    const scene = new THREE.Scene(),
      raycaster = new THREE.Raycaster(),
      mouse = new THREE.Vector2()
    scene.background = new THREE.Color("white")

    window.scene = scene
    this.scene = scene

    this.tobs.scene = scene
    this.tobs.raycaster = raycaster

    window.lights = []
    window.addLight = function addLight(...pos) {
      const color = 0xffffff
      const intensity = 1.2
      const light = new THREE.DirectionalLight(color, intensity)
      light.position.set(...pos)
      scene.add(light)
      // scene.add(light.target)
      window.lights.push(light)
    }
    addLight(5, 3, 2)
    addLight(-5, 3, 5)
    addLight(0, 3, -5)
    addLight(0, -1, 0)
    
    const manager = new THREE.LoadingManager()
    manager.onLoad = init
    // window.helper = helper

    // scene.add(helper)

    // const l = new THREE.AmbientLight(0xfff) // soft white light
    // scene.add(l)

    // const hemiLight = new THREE.HemisphereLight();
    // hemiLight.name = 'hemi_light';
    // scene.add(hemiLight);

    const light2  = new THREE.DirectionalLight(16777215, 2.5132741228718345);
    light2.position.set(0.5, 0, 0.866); // ~60º
    light2.name = 'main_light';
    camera.add( light2 );


    const progressbarElem = document.querySelector("#progressbar")
    manager.onProgress = (url, itemsLoaded, itemsTotal) => {
      progressbarElem.style.width = `${((itemsLoaded / itemsTotal) * 100) | 0}%`
    }

    const models = {
      kaliDevi: { url: "../models/kali-v6.glb" },
    }

    this.model = models

    {
      const glbLoader = new GLTFLoader(manager)
      let index = 0
      for (const model of Object.values(models)) {
        glbLoader.load(model.url, (glb) => {
          model.glb = glb
          if (model.url.indexOf("kali") > -1) {
            model.glb.name = "kali"
          } 
          // else if (model.url.indexOf("ganesh") > -1) {
          //   model.glb.name = "triMukhiGanesh"
          // }
          index++
        })
      }
    }
    function prepModelsAndAnimations() {
      Object.values(models).forEach((model) => {
        const animsByName = {}
        model.glb.animations.forEach((clip) => {
          animsByName[clip.name] = clip
        })
        model.animations = animsByName
      })
    }

    const mixerInfosByModel = {
      customCharacter: [],
      shiva: [],
      ironMan: [],
      drumShiva: [],
    }
    const mixerInfos = []

    const transform = new THREE.Object3D()

    let root = [],
      localScope = this

    function init() {
      // TBD
      // hide the loading bar
      const loadingElem = document.querySelector("#loading")
      loadingElem.style.display = "none"
      
      // prepModelsAndAnimations()

      Object.values(models).forEach((model, index) => {
        const clonedScene = SkeletonUtils.clone(model.glb.scene)
        const el = new THREE.Object3D()
        el.add(clonedScene)
        el.customType = "animated-character"
        el.name = model.glb.name
        scene.add(el)
        el.scale.multiplyScalar(.1,.1,.1)


        

        if (index == 0) {
          el.position.x = .5
          el.position.y = -1
          el.rotation.y = -1.8
          window.kaliRoot = el
        } 
        
        const mixer = new THREE.AnimationMixer(clonedScene)

        // const actions = Object.values(model.animations).map((clip) => {
        //   mixer.name = clip.name
        //   return mixer.clipAction(clip)
        // })
        // const mixerInfo = {
        //   mixer,
        //   actions,
        //   actionNdx: -1,
        //   actionsOf: model.glb.name,
        // }

        // mixerInfos.push(mixerInfo)
        // mixerInfosByModel[model.glb.name].push(mixerInfo)
        // playNextAction(mixerInfo)
        // localScope.createMessage()
      })

      {
        // const planeSize = 90

        // const loader = new THREE.TextureLoader()
        // const texture = loader.load("../img/three/checker.png")
        // texture.wrapS = THREE.RepeatWrapping
        // texture.wrapT = THREE.RepeatWrapping
        // texture.magFilter = THREE.NearestFilter
        // const repeats = planeSize / 3
        // texture.repeat.set(repeats, repeats)

        // const planeGeo = new THREE.PlaneGeometry(planeSize, planeSize)
        // const planeMat = new THREE.MeshPhongMaterial({
        //   map: texture,
        //   side: THREE.DoubleSide,
        // })
        // const mesh = new THREE.Mesh(planeGeo, planeMat)
        // mesh.rotation.x = Math.PI * -0.5
        // scene.add(mesh)
      }
      // if (!localScope.isMobile) {
      //   document.body.appendChild(controlsGizmo.domElement)
      // }
      // localScope.distanceSpanEl = document.getElementById("distance-span-el")
    }

    function playNextAction(mixerInfo, actionIndex, modifier) {
      const { actions, actionNdx } = mixerInfo
      if (modifier) {
        actions.forEach((action, ndx) => {
          action.enabled = false
        })
        actions[actionIndex].enabled = true
        actions[actionIndex].play()
      } else {
        const nextActionNdx = (actionNdx + 1) % actions.length
        mixerInfo.actionNdx = nextActionNdx
        actions.forEach((action, ndx) => {
          if (mixerInfo.actionsOf.toLowerCase().indexOf("shiva") > -1) {
            action.enabled = true
            action.play()
          } else {
            const enabled = ndx === nextActionNdx
            action.enabled = enabled
            if (enabled) {
              action.play()
            }
          }
        })
      }
    }

    function resizeRendererToDisplaySize(renderer) {
      const canvas = renderer.domElement
      let width, height
      if (!localScope.isLandscape) {
        width = canvas.clientWidth
        height = canvas.clientHeight
      } else {
        width = window.innerHeight
        height = window.innerWidth
      }
      const needResize = canvas.width !== width || canvas.height !== height
      if (needResize) {
        renderer.setSize(width, height, false)
      }
      return needResize
    }

    let then = 0
    let deltaTime = 0
    const render = (now) => {
      now *= 0.001 // convert to seconds
      deltaTime = now - then
      then = now

      if (resizeRendererToDisplaySize(renderer)) {
        const canvas = renderer.domElement
        camera.aspect = canvas.clientWidth / canvas.clientHeight
        camera.updateProjectionMatrix()
      }

      // for (const mixer of mixers) {

      for (const { mixer } of mixerInfos) {
        //Object.values([localScope.selected])
        mixer.update(deltaTime)
      }

      renderer.render(scene, camera)

      this.frameid = requestAnimationFrame(render)
    }
    requestAnimationFrame(render)

    const getIndex = (action, mixer) => {
      const m = mixerInfos.filter(
        (el) => el.actionsOf === localScope.selected
      )[0]
      if (m) {
        let indexToPlay

        if (action == "default") {
          indexToPlay = 0 // 3 - index of run action
        } else if (action == "run/walk") {
          if (m.actionsOf === "customCharacter") {
            indexToPlay = 3 // 3 - index of run action
          } else if (m.actionsOf === "ironMan") {
            indexToPlay = 1 // 1 - index of walk action
          }
        }
        return { indexToPlay, m }
      }
      return null
    }

    // window.onkeyup = (e) => {
    //   if (e.key == "ArrowUp") {
    //     let { indexToPlay, m } = getIndex("default")
    //     if (typeof indexToPlay != null && m) {
    //       playNextAction(m, indexToPlay, true)
    //     }
    //   }
    // }

    // window.onkeydown = (e) => {
    //   if (e.key == "ArrowUp") {
    //     let { indexToPlay, m } = { ...getIndex("run/walk") }

    //     if (indexToPlay && m) {
    //       playNextAction(m, indexToPlay, true)
    //     }
    //   }
    //   if (e.key == "ArrowLeft") {
    //     root[localScope.selected].rotation.y += 12 * 1 * deltaTime
    //   }
    //   if (e.key == "ArrowRight") {
    //     root[localScope.selected].rotation.y += 12 * -1 * deltaTime
    //   }

    //   switch (e.keyCode) {
    //     case 83: // up
    //       camera.position.z += 5
    //       break
    //     case 87: // down
    //       camera.position.z -= 5
    //       break
    //   }
    // }

    document.body.onpointermove = (event) => {
      mouse.x = (event.clientX / window.innerWidth) * 2 - 1
      mouse.y = -(event.clientY / window.innerHeight) * 2 + 1
      raycaster.setFromCamera(mouse, camera)

      // if (isDragging) {
      //   raycaster.ray.intersectPlane(plane, planeIntersect)
      //   dragObject.position.addVectors(planeIntersect, shift)
      // }
    }

    if (this.isLandscape) {
      this.$refs.canvas.classList.add("transform", "expand")
      this.$refs.controlBtns.classList.add("transform")
      this.gui.domElement.parentElement.classList.add("transform")
      // if (this.isMobile) {
      //   screen.orientation.lock("portrait-primary")
      // }
    }
  },
  methods: {
    createAudioMantra() {
      this.audioMantra = new Audio('../audio/mantras/Om-Kali-MahaKali-216-Times.mp3')
      this.audioMantra.autoplay = true
      this.audioMantra.oncanplaythrough = () => {
        this.audioMantra.play()
      }
      
      this.audioMantra.onended = () => {
        this.audioMantra.play()
      }
      
      
    },
    createMessage(){
       const messageCanvas = document.createElement('canvas'),
      messageContext = messageCanvas.getContext('2d')
      messageContext.font = "Bold 20px Arial"
      

      const message = '🎉Shri Ganesh Caturthi 2021🎉',
       metrics = messageContext.measureText(message),
       width = metrics.width

      messageContext.fillStyle = "rgba(0,0,0,0.95)" // black border
      messageContext.fillRect( 0,0, width+9,20+9)
      messageContext.fillStyle = "rgba(255,255,255,0.95)" // white filler
      messageContext.fillRect( 2,2, width+5,20+5 )
      messageContext.fillStyle = "rgba(0,0,0,1)" // text color
      messageContext.fillText(message, 4, 20)
      // canvas contents will be used for a texture
      const texture1 = new THREE.Texture(messageCanvas) 
      texture1.needsUpdate = true;

      var spriteMaterial = new THREE.SpriteMaterial( { 
        map: texture1
      })
      
      const sprite1 = new THREE.Sprite( spriteMaterial );
      sprite1.scale.set(3.5,3,1.2);
      sprite1.position.set( 2.5, 4, 1 );
      this.scene.add( sprite1 );
      window.sprite = sprite1
    },
    handlerOrientation(e) {
      console.log(`e`, e)
    },
    removeShiningBorder() {
      for (const el of Object.values(this.$refs)) {
        el.classList.remove("shining-border")
      }
    },

    setCharacter(i) {
      this.removeShiningBorder()

      let btn
      if (i == "customCharacter") {
        this.selected = "customCharacter"
        btn = this.$refs.ccBtn
      } else if (i == "ironMan") {
        this.selected = "ironMan"
        btn = this.$refs.imBtn
      } else if (i == "shiva") {
        this.selected = "shiva"
        btn = this.$refs.shBtn
      }
      btn.classList.add("shining-border")
    },

    setLang(lang) {
      this.language = lang
    },
  },
}
</script>

<style scoped>
html,
body {
  margin: 0;
  height: 100%;
}
#c {
  width: 100%;
  height: 100%;
  display: block;
}
#loading {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: xx-large;
  font-family: sans-serif;
}
#loading > div > div {
  padding: 2px;
}
.progress {
  width: 50vw;
  border: 1px solid black;
}
#progressbar {
  width: 0;
  transition: width ease-out 0.5s;
  height: 1em;
  background-color: #888;
  background-image: linear-gradient(
    -45deg,
    rgba(255, 255, 255, 0.5) 25%,
    transparent 25%,
    transparent 50%,
    rgba(255, 255, 255, 0.5) 50%,
    rgba(255, 255, 255, 0.5) 75%,
    transparent 75%,
    transparent
  );
  background-size: 50px 50px;
  animation: progressanim 2s linear infinite;
}

@keyframes progressanim {
  0% {
    background-position: 50px 50px;
  }
  100% {
    background-position: 0 0;
  }
}
</style>

<style>
#app {
  padding: 0;
}

.cr.number.has-slider {
  margin: 0;
}

button:hover {
  cursor: pointer;
}
button {
  font-family: sans-serif;
  font-size: 16px;
  color: #000;
  background: transparent;
  width: 100px;
  height: 40px;
  margin: 0 0 5px 0;
  border: none;
}

#controls {
  display: flex;
  flex-direction: column;
  position: absolute;
  right: 10px;
  top: 112px;
  z-index: 10;
}

.shining-border {
  -webkit-box-shadow: 0 0 17px 3px #ffff01, 0 0 4px 2px #ffff01;
  box-shadow: 0 0 17px 3px #ffff01, 0 0 4px 2px #ffff01;
  z-index: -1;
  -webkit-animation-name: gradient-shadow;
  animation-name: gradient-shadow;
  -webkit-animation-timing-function: ease;
  animation-timing-function: ease;
  -webkit-animation-duration: 2s;
  animation-duration: 2s;
  -webkit-animation-iteration-count: infinite;
  animation-iteration-count: infinite;
  border-radius: 5px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  -ms-border-radius: 5px;
  -o-border-radius: 5px;
}

h1 {
  font-size: 50px;
  margin: 0;
  position: relative;
  z-index: 3;
  padding: 20px;
  background-color: #060c1f;
  color: #fff;
  border-radius: 5px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  -ms-border-radius: 5px;
  -o-border-radius: 5px;
}

@-webkit-keyframes yellow-shadow {
  0% {
    top: 0;
    left: 0;
  }
  25% {
    top: 50%;
    left: 0;
  }
  50% {
    top: 50%;
    left: 50%;
  }
  75% {
    top: 0;
    left: 50%;
  }
  100% {
    top: 0;
    left: 0;
  }
}

@keyframes yellow-shadow {
  0% {
    top: 0;
    left: 0;
  }
  25% {
    top: 50%;
    left: 0;
  }
  50% {
    top: 50%;
    left: 50%;
  }
  75% {
    top: 0;
    left: 50%;
  }
  100% {
    top: 0;
    left: 0;
  }
}

@-webkit-keyframes cyan-shadow {
  0% {
    right: 0;
    bottom: 0;
  }
  25% {
    right: 0;
    bottom: 50%;
  }
  50% {
    right: 50%;
    bottom: 50%;
  }
  75% {
    right: 50%;
    bottom: 0;
  }
  100% {
    right: 0;
    bottom: 0;
  }
}

@keyframes cyan-shadow {
  0% {
    right: 0;
    bottom: 0;
  }
  25% {
    right: 0;
    bottom: 50%;
  }
  50% {
    right: 50%;
    bottom: 50%;
  }
  75% {
    right: 50%;
    bottom: 0;
  }
  100% {
    right: 0;
    bottom: 0;
  }
}

@-webkit-keyframes gradient-shadow {
  0% {
    -webkit-box-shadow: 0 0 17px 3px #c586c0, 0 0 4px 2px #c586c0;
    box-shadow: 0 0 17px 3px #c586c0, 0 0 4px 2px #c586c0;
  }
  20% {
    -webkit-box-shadow: 0 0 17px 3px #0ff, 0 0 4px 2px #0ff;
    box-shadow: 0 0 17px 3px #0ff, 0 0 4px 2px #0ff;
  }
  40% {
    -webkit-box-shadow: 0 0 17px 3px #0f0, 0 0 4px 2px #0f0;
    box-shadow: 0 0 17px 3px #0f0, 0 0 4px 2px #0f0;
  }
  60% {
    -webkit-box-shadow: 0 0 17px 3px #ffff01, 0 0 4px 2px #ffff01;
    box-shadow: 0 0 17px 3px #ffff01, 0 0 4px 2px #ffff01;
  }
  80% {
    -webkit-box-shadow: 0 0 17px 3px #f00, 0 0 4px 2px #f00;
    box-shadow: 0 0 17px 3px #f00, 0 0 4px 2px #f00;
  }
  100% {
    -webkit-box-shadow: 0 0 17px 3px #c586c0, 0 0 4px 2px #c586c0;
    box-shadow: 0 0 17px 3px #c586c0, 0 0 4px 2px #c586c0;
  }
}

@keyframes gradient-shadow {
  0% {
    -webkit-box-shadow: 0 0 17px 3px #c586c0, 0 0 4px 2px #c586c0;
    box-shadow: 0 0 17px 3px #c586c0, 0 0 4px 2px #c586c0;
  }
  20% {
    -webkit-box-shadow: 0 0 17px 3px #0ff, 0 0 4px 2px #0ff;
    box-shadow: 0 0 17px 3px #0ff, 0 0 4px 2px #0ff;
  }
  40% {
    -webkit-box-shadow: 0 0 17px 3px #0f0, 0 0 4px 2px #0f0;
    box-shadow: 0 0 17px 3px #0f0, 0 0 4px 2px #0f0;
  }
  60% {
    -webkit-box-shadow: 0 0 17px 3px #ffff01, 0 0 4px 2px #ffff01;
    box-shadow: 0 0 17px 3px #ffff01, 0 0 4px 2px #ffff01;
  }
  80% {
    -webkit-box-shadow: 0 0 17px 3px #f00, 0 0 4px 2px #f00;
    box-shadow: 0 0 17px 3px #f00, 0 0 4px 2px #f00;
  }
  100% {
    -webkit-box-shadow: 0 0 17px 3px #c586c0, 0 0 4px 2px #c586c0;
    box-shadow: 0 0 17px 3px #c586c0, 0 0 4px 2px #c586c0;
  }
}

@-webkit-keyframes half-yellow-shadow {
  0% {
    top: 0;
    left: 0;
    height: 50%;
    width: 50%;
  }
  16.66% {
    top: 0;
    left: 0;
    height: 50%;
    width: 100%;
  }
  32.32% {
    top: 0;
    left: 50%;
    height: 50%;
    width: 50%;
  }
  49.98% {
    top: 50%;
    left: 50%;
    height: 50%;
    width: 50%;
  }
  66.64% {
    top: 50%;
    left: 0;
    height: 50%;
    width: 100%;
  }
  83.3% {
    top: 50%;
    left: 0;
    height: 50%;
    width: 50%;
  }
  100% {
    top: 0;
    left: 0;
    height: 50%;
    width: 50%;
  }
}

@keyframes half-yellow-shadow {
  0% {
    top: 0;
    left: 0;
    height: 50%;
    width: 50%;
  }
  16.66% {
    top: 0;
    left: 0;
    height: 50%;
    width: 100%;
  }
  32.32% {
    top: 0;
    left: 50%;
    height: 50%;
    width: 50%;
  }
  49.98% {
    top: 50%;
    left: 50%;
    height: 50%;
    width: 50%;
  }
  66.64% {
    top: 50%;
    left: 0;
    height: 50%;
    width: 100%;
  }
  83.3% {
    top: 50%;
    left: 0;
    height: 50%;
    width: 50%;
  }
  100% {
    top: 0;
    left: 0;
    height: 50%;
    width: 50%;
  }
}

@-webkit-keyframes half-cyan-shadow {
  0% {
    bottom: 0;
    right: 0;
    height: 50%;
    width: 50%;
  }
  16.66% {
    bottom: 0;
    right: 0;
    height: 50%;
    width: 100%;
  }
  32.32% {
    bottom: 0;
    right: 50%;
    height: 50%;
    width: 50%;
  }
  49.98% {
    bottom: 50%;
    right: 50%;
    height: 50%;
    width: 50%;
  }
  66.64% {
    bottom: 50%;
    right: 0;
    height: 50%;
    width: 100%;
  }
  83.3% {
    bottom: 50%;
    right: 0;
    height: 50%;
    width: 50%;
  }
  100% {
    bottom: 0;
    right: 0;
    height: 50%;
    width: 50%;
  }
}

@media screen and (max-width: 600px) {
  #c {
    max-height: 500px;
  }
}

#c {
  min-height: 600px;
  z-index: 1;
}

.transform {
  transform: rotate(90deg);
}

.expand {
  width: 540px !important;
}

.dg.ac.transform {
  top: 400px;
  left: unset;
  right: 25px;
}
</style>
